export const ENTITY_PATH = '/settings';

export const SETTING_RULE_NAME_MAX_LENGTH = 100;
